
const benefits = [
  { text: 'Data-driven decision frameworks', icon: 'ri-bar-chart-box-line' },
  { text: 'Executive-level reporting visibility', icon: 'ri-eye-line' },
  { text: 'Regulatory-conscious architecture', icon: 'ri-shield-keyhole-line' },
  { text: 'Scalable automation systems', icon: 'ri-settings-3-line' },
  { text: 'Long-term infrastructure thinking', icon: 'ri-building-4-line' },
];

export default function WhyScaleNorthSection() {
  return (
    <section className="bg-white py-32">
      <div className="max-w-[1280px] mx-auto px-8 lg:px-20">
        <div className="flex items-start gap-16">
          {/* Left content */}
          <div className="flex-1">
            <h2 className="text-[44px] font-semibold text-[#0B1F3A] mb-14 leading-tight">
              Enterprise discipline.<br />Modern execution.
            </h2>

            <div className="space-y-6 mb-14">
              {benefits.map((item, index) => (
                <div key={index} className="flex items-center gap-5 group">
                  <div className="w-10 h-10 rounded-lg bg-[#0B1F3A]/5 flex items-center justify-center flex-shrink-0 group-hover:bg-[#1EB6B0]/10 transition-colors">
                    <i className={`${item.icon} text-lg text-[#1EB6B0]`}></i>
                  </div>
                  <p className="text-[17px] text-[#0B1F3A]/75 leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>

            <p className="text-[15px] text-[#0B1F3A]/50 max-w-[480px] leading-relaxed">
              We operate with the discipline of a consulting firm and the execution speed of a modern systems partner.
            </p>
          </div>

          {/* Right visual */}
          <div className="w-[440px] flex-shrink-0">
            <div className="w-full h-[480px] rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/4b5c1cbd27c4d77625d58a067dc0a3b1.jpg"
                alt="Enterprise performance systems"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
